<template>
    <div>
        <b-form-group :id="groupId" v-bind="$attrs" :class="!useLabel ? 'input-no-label' : ''">
            <template v-if="useLabel" v-slot:label>{{ labelStr }} <span v-if="isRequired" class="required"></span></template>
            <div v-if="isAllowEdit && !isUpdatable">
                <v-select :components="{OpenIndicator}" :label="optionsLabel" append-to-body :options="options" :value="selectedValue" :filterable="false" @input="setSelected" :searchable="false" :clearable="false" v-bind="$attrs"></v-select>
                <b-form-invalid-feedback :id="feedbackId" :state="state">
                    {{ errorMessage }}
                </b-form-invalid-feedback>
            </div>
            <div :class="useLabel ? 'input-label-detail' : ''" v-else-if="isUpdatable">
                <span>{{ selectedValue }}</span>
                <span class="float-right"><a v-if="isAllowEdit" @click="onPopoverShow" id="popover-button-sync"><app-icon-edit /></a></span>
            </div>
            <div v-else>
                {{ selectedValue }}
            </div>
        </b-form-group>
        <b-popover :show.sync="popoverShow" target="popover-button-sync" :title="label" placement="bottomleft">
            <v-select :label="optionsLabel" append-to-body :options="options" :value="popoverSelectedValue" :filterable="false" :searchable="false" :clearable="false" v-bind="$attrs">
                <template #selected-option>
                    <app-long-text :maxLength="18" :text="popoverSelectedValue != '' && popoverSelectedValue != null ? popoverSelectedValue : ''" />
                </template>
            </v-select>
            <div class="popover-action float-right mt-2 mb-1">
                <b-button @click="popoverShow = false" size="sm" class="btn-default-white">Cancel</b-button>
                <b-button @click="setSelected" size="sm" class="btn-default ml-2">Save</b-button>
            </div>
        </b-popover>
    </div>
</template>
<script>
export default {
    props: ["model", "id", "name", "selected", "errorMessage", "options", "state", "isEditable", "isUpdatable", "optionsLabel", "optionsKey", "change", "label", "isRequired", "onSelectMethod", "isSelectMethodExists","nolabel"],
    data() {
        return {
            OpenIndicator: {
                render: createElement => createElement('b-icon-chevron-down',  {class: {'btn-secondary': true}}),
            },
            labelStr: this.label,
            value:"",
            selectedValue: this.selected,
            inputModel: this.model,
            groupId : "fieldset-" + this.id,
            feedbackId : "input-" + this.id + "-live-feedback",
            popoverSelectedValue: this.model,
            popoverShow: false,
        }
    }, 
    methods: {
        setSelected(value) {
            if (this.popoverShow) {
                this.popoverSelectedValue = value != null ? value[this.optionsLabel] : null;
                this.$emit('update:model', this.inputModel);
                this.$emit("change");
            } else {
                if (!this.isSelectMethodExists) {
                    this.inputModel = value != null ? value[this.optionsKey] : null;
                    this.selectedValue = value != null ? value[this.optionsLabel] : null;
                    this.$emit('update:model', this.inputModel);
                    this.$emit("change");
                } else {
                    this.$emit("onSelectMethod", value);
                }
            }
            this.popoverShow = false;
        },
        onPopoverShow() {
            this.popoverSelectedValue = this.selectedValue;
            this.popoverShow = true;
        }
        // searchData(search, loading) {
        //     this.$emit("input", search);
        // }
    },
    computed : {
        isAllowEdit : {
            get: function() {
                if (this.isEditable != undefined) return this.isEditable;
                else return true;
            }
        },
        useLabel() {
            if (this.nolabel != null && this.nolabel != undefined && this.nolabel != '') {
                if (this.nolabel) return false;
            }
            return true;
        }
    },
    watch: {
        model(newValue) {
            this.inputModel = newValue;
            if (newValue == null || newValue == '') {
                this.selectedValue = '';
            }
        },
        selected(newValue) {
            this.selectedValue = newValue;
        },
        label : function(val) {
            this.labelStr = val;
        }
    }
}
</script>
<style lang="scss" scoped>
.input-group-text {
    font-size: 0.7rem !important;
}
::v-deep.vs__dropdown-toggle {
    background: #ffffff !important;
}

::v-deep.input-no-label .form-row legend {
    display: none !important;
}
</style>